<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="订单编号" prop="id">
                <a-input v-model="queryParam.id" placeholder="请输入订单编号" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="用户姓名" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入用户姓名" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <template >
              <a-col :md="8" :sm="24">
                <a-form-item label="订单状态" prop="status">
                  <a-select v-model="queryParam.status" allow-clear>
                    <a-select-option :value="-1">已取消</a-select-option>
                    <a-select-option :value="0">待支付</a-select-option>
                    <a-select-option :value="1">待发货</a-select-option>
                    <a-select-option :value="2">待收货</a-select-option>
                    <a-select-option :value="5">待评价</a-select-option>

                    <a-select-option :value="3">已完成</a-select-option>
<!--                    <a-select-option :value="4">售后中</a-select-option>-->
                    <!-- <a-select-option :value="6">已收货</a-select-option> -->
                    <a-select-option :value="7">交易关闭</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
              <a-form-model-item label="创建订单时间"  >
                <a-range-picker format="YYYY-MM-DD" @change="onChange" v-model="date"/>
              </a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="支付方式" prop="payType">
                  <a-select v-model="queryParam.payType" placeholder="请选择" allow-clear>
                    <a-select-option :value="1">PayPal</a-select-option>
                    <a-select-option :value="2">支付宝</a-select-option>
                    <a-select-option :value="0">余额</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="推送旺店通" prop="isPushWdt">-->
<!--                  <a-select v-model="queryParam.isPushWdt" placeholder="请选择">-->
<!--                    <a-select-option :value="0">未推送</a-select-option>-->
<!--                    <a-select-option :value="1">推送成功</a-select-option>-->
<!--                    <a-select-option :value="2">推送失败</a-select-option>-->
<!--                  </a-select>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
            </template>

            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" type="primary" @click="handleExport" v-hasPermi="['address:book:export']">
          <a-icon type="download" />导出
        </a-button>
                <a-button type="primary" style="margin-left: 8px" @click="handleShippedExport" v-hasPermi="['order:order:export']">
          <a-icon type="download" />导出待发货
        </a-button>
                <a-button type="dashed" style="margin-left: 8px" @click="$refs.importExcel.importExcelHandleOpen()">
                            <a-icon type="import" />导入
                         </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>

              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <!-- <div class="table-operations"> -->
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['order:order:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['order:order:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['order:order:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['order:order:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <!-- <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" /> -->
      <!-- </div> -->
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
<!--      <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open"  @close="onClose">-->
      <create-form-detail :orderId="orderId"
        ref="createFormDetail"

      />
      <!-- 上传文件 -->
      <import-excel ref="importExcel" @ok="getList" />
<!--      </a-drawer>-->
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 300px)'}"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
      <span slot="index" slot-scope="text, record,index">
          {{(current-1)*size+index+1}}
        </span>
        <span slot="payTime" slot-scope="text, record">
          {{ parseTime(record.payTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" v-hasPermi="['order:order:edit']" />-->
          <a @click="handleInfo(record)" v-hasPermi="['order:order:edit']">
            <a-icon type="file" />查看详情
          </a>

<!--          <a-divider v-if="record.isPushWdt == 2" type="vertical" v-hasPermi="['order:order:edit']" />-->
<!--          <a v-if="record.isPushWdt == 2" @click="handlePush(record)" v-hasPermi="['order:order:edit']">-->
<!--            <a-icon type="edit" />推送旺店通-->
<!--          </a>-->
<!--          <a-divider type="vertical" v-hasPermi="['order:order:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['order:order:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageOrderOrder,listOrderOrder, delOrderOrder, importData } from '@/api/order/order'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import CreateFormDetail from '../orderItem/index'
import ImportExcel from './modules/ImportExcel'

export default {
  name: 'OrderOrder',
  components: {
    CreateForm,
    CreateFormDetail,
    ImportExcel
  },
  props:["type"],

  mixins: [tableMixin],
  data () {
    return {
      date:[],
      list: [],
      open:false,
      orderId:null,
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        orderNo: null,
        type:2,
        pushWDT:null,
        payType:null,
        status: null,
        refundStatus:null,
        productId: null,
        totalAmount: null,
        discountAmount: null,
        userId: null,
        nickname: null,
        payAmount: null,
        reduceScores: null,
        reduceVoucher: null,
        freightAmount: null,
        payMethod: null,
        payTime: null,
        quantity: null,
        addressId: null,
        logisticsCompany: null,
        logisticsNumber: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        {
          title: '订单编号',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center',
          width:180
        },
        {
          title: '用户名称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f == 0){
              return '待支付'
            }else if(f == 1){
              return '待发货'
            }else if(f == 2){
              return '待收货'
            }else if(f == 3){
              return '已完成'
            }else if(f == 4){
              return '已售后'
            }else if(f == 5){
              return '待评价'
            }else if(f == -1){
              return '已取消'
            }
          }
        },
        // {
        //   title: '订单类型',
        //   dataIndex: 'type',
        //   ellipsis: true,
        //   align: 'center',
        //   customRender(f){
        //     if(f ==1){
        //       return '兑换商城'
        //     }
        //     else if(f ==2){
        //       return '闲橙优选'
        //     }
        //     else{
        //       return '闲橙健康'
        //     }
        //   }
        // },
        {
          title: '总金额',
          dataIndex: 'totalAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '现金券',
          dataIndex: 'reduceVoucher',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '优惠金额',
        //   dataIndex: 'discountAmount',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '支付金额',
          dataIndex: 'payAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '支付方式',
          dataIndex: 'payType',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f == 1){
              return 'PayPal'
            }
            else if(f ==2){
              return '支付宝'
            }
            else  if(f ==0){
              return '余额'
            }
          }
        },
        // {
        //   title: '支付时间',
        //   dataIndex: 'payTime',
        //   scopedSlots: { customRender: 'payTime' },
        //   // ellipsis: true,
        //   align: 'center',
        //   width:180
        // },
        // {
        //   title: '是否推送旺店通',
        //   dataIndex: 'isPushWdt',
        //   ellipsis: true,
        //   align: 'center',
        //   customRender(f){
        //     if(f == 0){
        //       return '未推送'
        //     }
        //     else if(f==1){
        //       return '推送成功'
        //     }
        //     else{
        //       return '推送失败'
        //     }
        //   }
        // },
        // {
        //   title: '消耗积分数',
        //   dataIndex: 'reduceScores',
        //   ellipsis: true,
        //   align: 'center'
        // },

        // {
        //   title: '运费',
        //   dataIndex: 'freightAmount',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          // ellipsis: true,
          align: 'center',
          width:180
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 120,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed:'right',
        }
      ]
    }
  },
  filters: {
  },
  mounted() {
      if(this.type!='tk'){
        this.getList()
      }
  },
  // created () {
  //   this.queryParam.userId = this.$route.query.userId
  //   // if (this.$route.query.types)  {
  //   //    this.queryParam.types = this.$route.query.types.split(',')
  //   // }
  //   this.getList()
  // },
  computed: {
  },
  watch: {
  },
  methods: {
    onClose() {
      this.open = false
    },
    onChange(date, dateString) {
      console.log( dateString," dateString")
      this.date = dateString;
      this.getList()
    },
    /** 查询订单信息列表 */
    getList () {
      this.loading = true
      this.queryParam.createBeginTime = null
      this.queryParam.createEndTime = null
        if(this.date[0]){
          this.queryParam.createBeginTime= this.date[0]==""?'':this.date[0]+' 00:00:00'
        }
        if(this.date[1]){
          this.queryParam.createEndTime= this.date[1]==""?'':this.date[1]+' 23:59:59'
        }
     pageOrderOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },
    goList(record, type) {
      var this_ = this
      this_.$nextTick(() => {
        this_.queryParam.userId = record.id
        // this_.queryParam.type = type
        this_.list = []
        this_.total = 0
        this_.current = 0
        this_.size = 0
        this_.getList()//这是我自定义的
      })
    },
    handleInfo(record){
      this.open = true
      this.orderId = record.id
      this.$nextTick(()=>{
        this.$refs.createFormDetail.getOrderInfo(record.id,'2')
      })

          // this.$router.push({path:"/order/manage/orderItem",query:{orderId:record.id,type:'2'}})
    },
    handlePush(record){
      pushWDT({id:record.id}).then(res =>{
        if(res.success){
          this.$message.success("成功")
        }else{
          this.$message.error(res.message)
        }
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        orderNo: undefined,
        type:2,
        status: undefined,
        productId: undefined,
        totalAmount: undefined,
        discountAmount: undefined,
        userId: undefined,
        payAmount: undefined,
        reduceScores: undefined,
        reduceVoucher: undefined,
        freightAmount: undefined,
        payMethod: undefined,
        payTime: undefined,
        quantity: undefined,
        addressId: undefined,
        logisticsCompany: undefined,
        logisticsNumber: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delOrderOrder(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('order/order/export', {
            ...that.queryParam
          }, `订单信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    // 导出待发货列表
    handleShippedExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('/orderItem/orderItem/exportShipped', {
            ...that.queryParam
          }, `订单信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.open = false
      this.fileList = []
      // 关闭后刷新列表
      this.$emit('ok')
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.open = true
    },
    beforeUpload (file) {
      this.fileList = [file]
      return false
    },
      /** 导入excel */
    importExcelHandleChange () {
  this.uploading = true
  const { fileList } = this
  const formData = new FormData()
  formData.append('file', fileList[0])
  importData(formData).then(response => {
    if(response.code == 1 || response.code == 20001) {
      this.fileList = []
      this.$message.success(response.message)
      this.open = false
      this.$emit('ok')
    }else {
      this.$message.error(response.message)
      return
    }

  }).finally(() => {
    this.uploading = false
  })
},
  }
}
</script>
